module.exports = __webpack_public_path__ + "static/img/technology-left.ad3da182.gif";